import React from "react";
import "./Page.css";

const Privacy = () => (
  <div className="ap-page-container">
    <h1>Privacy Policy</h1>
    <p>Last updated: January 11, 2026</p>

    <div className="ap-content-section">
      <h2>1. Introduction</h2>
      <p>
        Welcome to AutoPromote. We respect your privacy and are committed to protecting your
        personal data. This privacy policy will inform you as to how we look after your personal
        data when you visit our website and use our automation services, and tell you about your
        privacy rights and how the law protects you.
      </p>

      <h2>2. Information We Collect</h2>
      <p>
        We may collect, use, store and transfer different kinds of personal data about you which we
        have grouped together follows:
      </p>
      <ul>
        <li>
          <strong>Identity Data:</strong> includes username or similar identifier, and social media
          profile information.
        </li>
        <li>
          <strong>Contact Data:</strong> includes email address.
        </li>
        <li>
          <strong>Technical Data:</strong> includes internet protocol (IP) address, your login data,
          browser type and version, time zone setting and location, browser plug-in types and
          versions, operating system and platform, and other technology on the devices you use to
          access this website.
        </li>
        <li>
          <strong>Usage Data:</strong> includes information about how you use our website, products
          and services.
        </li>
        <li>
          <strong>Content Data:</strong> includes the videos, images, captions, and other content
          you upload for the purpose of distribution to social media platforms.
        </li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <p>
        We will only use your personal data when the law allows us to. Most commonly, we will use
        your personal data in the following circumstances:
      </p>
      <ul>
        <li>To register you as a new customer.</li>
        <li>To provide our content automation and distribution services.</li>
        <li>To manage our relationship with you.</li>
        <li>To improve our website, products/services, marketing and customer relationships.</li>
      </ul>

      <h2>4. Third-Party Services</h2>
      <p>
        Our service integrates with third-party social media services (such as YouTube, TikTok,
        Twitter, LinkedIn, etc.). When you use our service to post content to these platforms, you
        are also subject to their respective privacy policies. We encourage you to read the privacy
        policy of every website and service you visit.
      </p>

      <h2>5. Data Security</h2>
      <p>
        We have put in place appropriate security measures to prevent your personal data from being
        accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In
        addition, we limit access to your personal data to those employees, agents, contractors and
        other third parties who have a business need to know.
      </p>

      <h2>6. Data Retention</h2>
      <p>
        We will only retain your personal data for as long as reasonably necessary to fulfill the
        purposes we collected it for, including for the purposes of satisfying any legal,
        regulatory, tax, accounting or reporting requirements.
      </p>

      <h2>7. Your Legal Rights</h2>
      <p>
        Under certain circumstances, you have rights under data protection laws in relation to your
        personal data, including the right to request access, correction, erasure, restriction,
        transfer, or to object to processing.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        If you have any questions about this privacy policy or our privacy practices, please contact
        us at support@autopromote.com.
      </p>
    </div>
  </div>
);

export default Privacy;
